import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {siteCountryFromLocale} from '../utils/optimizely-attributes'
import {fxPageView, startFxBehaviourTracking} from '../utils/optimizely-fx-behaviour'
import {useOptimizelyFxConfig} from './use-optimizely-fx-config'

/* Mounts the behavioural FX listeners once FX is on and reports every route
 * change as a page view. Effects only — nothing reaches the render output. */
export function useOptimizelyFxBehaviour() {
    const {enabled, localeId} = useOptimizelyFxConfig()
    const {pathname} = useLocation()

    useEffect(() => {
        if (enabled) startFxBehaviourTracking({siteCountry: siteCountryFromLocale(localeId)})
    }, [enabled, localeId])

    useEffect(() => {
        if (enabled) fxPageView(pathname)
    }, [enabled, pathname])
}
